import { svgUnitCtrl } from './svg.unit.controller';
import template from './svg.unit.html';

export const svgUnit: angular.IDirectiveFactory = () => ({
  bindToController: true,
  controller: svgUnitCtrl,
  controllerAs: 'vm',
  template,
  restrict: 'A',
  scope: {
    unit: '=',
    publicMode: '=?',
  },
});
